import { supabase, hasSupabase } from './supabase.js';

const BILLING_URL = import.meta.env.VITE_BILLING_WORKER_URL || '';

async function callWorker(path, body) {
  if (!hasSupabase) throw new Error('Supabase not configured');
  if (!BILLING_URL) throw new Error('Billing worker URL not configured (set VITE_BILLING_WORKER_URL)');
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not signed in');
  const res = await fetch(`${BILLING_URL}${path}`, {
    method: 'POST',
    headers: {
      'authorization': `Bearer ${session.access_token}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify(body || {}),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `Request failed: ${res.status}`);
  return data;
}

export async function startCheckout(planId) {
  const { url } = await callWorker('/checkout', { plan_id: planId });
  window.location.href = url;
}

export async function openPortal() {
  const { url } = await callWorker('/portal');
  window.location.href = url;
}
